import React, { useRef, useState } from 'react';
import Accordion from '../../atoms/Accordion';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import Styles from './BancoDoAutoPerguntas.css';

function BancoDoAutoPerguntas({
  classsection,
  faqtitle,
  faqsubtitle,
  imgpng,
  imgwebp,
  imgalt,
  faqs = [],
  faqs2 = [],
}) {
  const accRefs = useRef(faqs.map(() => React.createRef()));

  const handleAccChange = (index, open) => {
    if (!open) return;
    accRefs.current.forEach((ref, i) => {
      if (i !== index && ref.current) {
        ref.current.close();
      }
    });
  };

  const [verMais, setVerMais] = useState(false);
  const QTD_VISIVEL = 2;

  return (
    <section id="perguntas" className={classsection}>
      <ContainerHome24>
        <div className="perguntas-contain">
          <picture>
            <source type="image/webp" srcSet={imgwebp} />
            <source type="image/png" srcSet={imgpng} />
            <img src={imgpng} alt={imgalt} className="img-perguntas" />
          </picture>
          <div className="group-perguntas">
            <h2 className="title-perguntas">{faqtitle}</h2>
            {faqs.map((faq, index) => (
              <Accordion
                key={index}
                title={faq.pergunta}
                accordionRef={accRefs.current[index]}
                onChange={(open) => handleAccChange(index, open)}
              >
                <p dangerouslySetInnerHTML={{ __html: faq.resposta }} />
              </Accordion>
            ))}
            <h2 className="title-perguntas">{faqsubtitle}</h2>
            {faqs2.map((faq, index) => {
              const oculto = index >= QTD_VISIVEL && !verMais;
              return (
                <div key={index} style={oculto ? { display: 'none' } : undefined}>
                  <Accordion
                    title={faq.pergunta}
                    accordionRef={accRefs.current[index]}
                    onChange={(open) => handleAccChange(index, open)}
                  >
                    <p dangerouslySetInnerHTML={{ __html: faq.resposta }} />
                  </Accordion>
                </div>
              );
            })}

            {faqs2.length > QTD_VISIVEL && !verMais && (
              <button className="link-faq" type="button" onClick={() => setVerMais(true)}>
                Ver mais
              </button>
            )}
            {verMais && (
              <>
                <br />
                <a href="duvidas-frequentes.html" className="link-faq">
                  Mostrar todas as perguntas
                </a>
              </>
            )}
          </div>
        </div>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default BancoDoAutoPerguntas;
